var render, staticRenderFns
import script from "./LxPdfViewer.vue?vue&type=script&lang=js"
export * from "./LxPdfViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7de766e",
  null
  
)

export default component.exports